import { Pipe, PipeTransform } from "@angular/core";
import { DecimalPipe } from "@angular/common";

@Pipe({
    name: "integerDigits",
    standalone: false
})
export class IntegerDigitsPipe implements PipeTransform {
	constructor(private numberPipe: DecimalPipe) {}

	transform(value: any, numberOfDigits: number): string {
		const transformFormat = `${numberOfDigits}.9-9`;

		const transformedValue = this.numberPipe.transform(
			value,
			transformFormat
		);
		return transformedValue.split(".")[0];
	}
}
